import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import Html from "./html";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import environment from "../../environment";

const Users = () => {
  const searchState = { data: "" }
  const user = useSelector((state) => state.user)
  const [filters, setFilter] = useState({ page: 1, count: 10, search: "", role: environment.userRole })
  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)
  const history = useNavigate()

  useEffect(() => {
    setFilter({ ...filters, search: searchState.data })
    getData({ search: searchState.data })
  }, [])

  const sortClass = (key) => {
    let cls = "fa-sort";
    if (filters.key == key && filters.sorder == "asc") cls = "fa-sort-up";
    else if (filters.key == key && filters.sorder == "desc")
      cls = "fa-sort-down";
    return "fa " + cls;
  }

  const sorting = (key) => {
    let sorder = "asc";
    if (filters.key == key) {
      if (filters.sorder == "asc") {
        sorder = "desc";
      } else {
        sorder = "asc";
      }
    }

    let sortBy = `${key} ${sorder}`;
    setFilter({ ...filters, sortBy, key, sorder });
    getData({ sortBy, key, sorder });
  }

  const getData = (p = {}) => {
    loader(true)
    let filter = { ...filters, ...p }
    ApiClient.get("user/frontend/lisitng", filter).then((res) => {
      if (res.success) {
        setData(res?.data)
        setTotal(res.total)
      }
      loader(false)
    })
  }

  const clear = () => {
    let f = {
      search: "",
      status: "",
    };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  }

  const filter = (p = {}) => {
    let f = {
      ...p,
    };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  }

  const deleteUser = (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete this ${item?.roleDetails?.name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true);
        ApiClient.delete(`user/delete?id=${item?._id || item?.id}`).then((res) => {
          if (res.success) {
            clear();
          }
          loader(false);
        });
      }
    });
  }

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  }

  const count = (e) => {
    setFilter({ ...filters, count: e });
    getData({ ...filters, count: e });
  }

  const changestatus = (e, key) => {
    setFilter({ ...filters, [key]: e });
    getData({ [key]: e });
  }

  const statusChange = (itm) => {
    let status = "active";
    if (itm.status == "active") status = "deactive";
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status == "active" ? "Activate" : "Deactivate"
        } this ${itm?.roleDetails?.name}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        loader(true)
        ApiClient.put("user/status/change", { id: itm?._id || itm?.id, status }).then(res => {
          if (res.success) {
            getData()
          }
          loader(false)
        })

      }
    });
  }

  const edit = (id) => {
    history(`/users/edit/${id}`);
  }

  const view = (id) => {
    let url = `/users/detail/${id}`;
    history(url);
  }

  const uploadFile = (e) => {
    let files = e.target.files;
    let file = files?.item(0);
    let url = "user/import-users";
    if (!file) return;
    loader(true);
    ApiClient.postFormFileData(url, { file }).then((res) => {
      if (res.success) {
        // console.log("res", res);
      }
      loader(false);
    });
  }

  const isAllow = (key = "") => {
    if (user?.role?.name == "admin") return true
    let permissions = user?.role?.permissions?.[0]
    let value = permissions?.[key]
    return value;
  };

  const handleSearch = (e) => {
    setFilter({ ...filters, search: e.target.value });
    if (e.target.value === "") {
      getData({ search: "" })
    }
  }

  return (
    <>
      <Html
        edit={edit}
        view={view}
        clear={clear}
        sortClass={sortClass}
        sorting={sorting}
        isAllow={isAllow}
        count={count}
        pageChange={pageChange}
        deleteUser={deleteUser}
        filters={filters}
        setFilter={setFilter}
        filter={filter}
        data={data}
        total={total}
        statusChange={statusChange}
        changestatus={changestatus}
        uploadFile={uploadFile}
        handleSearch={handleSearch}
      />
    </>
  );
};

export default Users;
